import type { Space } from '../models';

/** Find the space whose name matches (used right after creating a space, whose code is assigned by the server). */
export function findSpaceByName(spaces: Space[], name: string): Space | undefined {
  return spaces.find((space) => space.spaceName === name);
}
